import { ComponentRoute } from '@/classes'

const PaymentListRoutes = {
  PaymentListListView: new ComponentRoute('/paymentlist', 'PaymentListListView')
}

export default PaymentListRoutes
